import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {FilterSpecification, LayerSpecification, SymbolLayerSpecification} from "mapbox-gl";
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type FacilityLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
  floorId?: number | null
}

// Component ----

function FacilityLayer({source = '', enabledLayers, floorId}: FacilityLayerProps) {

  // Filters
  const facilityFilter: FilterSpecification = ["==", ["get", "type"], "facility"];
  const filter: FilterSpecification = floorId ? [
    'all',
    facilityFilter,
    ['==', ['get', 'type', ['get', 'location']], 'floor'],
    ['==', ['get', 'id', ['get', 'location']], floorId],
  ] : facilityFilter;

  // Layout Properties
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.FACILITY) ? "visible" : "none" };

  return (
    <Mapbox.Layer
      type="symbol"
      id="ngage-facility"
      source={source}
      filter={filter}
      layout={{...facilityLayout, ...layout}}
      paint={facilityPaint}
    />
  );
}

// Styles ----

const facilityLayout: SymbolLayerSpecification['layout'] = {
  "icon-image": "ngage-pin-facility",
  "icon-size": 0.6,
  "icon-anchor": "bottom",
  "icon-keep-upright": true,
  "icon-allow-overlap": true,
  "text-field": ["get", "name"],
  "text-anchor": "top",
}

const facilityPaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}

export default FacilityLayer;